/**
 * What the lists overview shows per column of the register (spec-63 E5, design §4.7). The register decides
 * which columns exist, in which order and which sort; this file only draws a cell of a `ListRow`.
 */
import { CategoryCell, DayCell, OwnerCell, PlainText, RelativeTime } from '../list/commonCells'
import type { ColumnRender } from '../list/RecordListPage'
import { ListDateCell, ListMembersCell, ListNameCell, ListTypeCell, MailchimpCell } from './ListCells'
import type { ListRow } from './types'

const COLUMNS: Record<string, ColumnRender<ListRow>> = {
  name: { header: 'Lijst', className: 'min-w-56', cell: (row) => <ListNameCell row={row} /> },
  kind: { header: 'Soort', cell: (row) => <CategoryCell category={row.kind} /> },
  starts_on: { header: 'Datum', cell: (row) => <ListDateCell row={row} /> },
  ends_on: { header: 'Einddatum', cell: (row) => <DayCell day={row.ends_on} /> },
  location: { header: 'Plaats', cell: (row) => <PlainText value={row.location} /> },
  type: { header: 'Type', cell: (row) => <ListTypeCell row={row} /> },
  members_count: { header: 'Leden', cell: (row) => <ListMembersCell row={row} /> },
  owner: { header: 'Eigenaar', cell: (row) => <OwnerCell owner={row.owner} /> },
  mailchimp_sync: { header: 'Mailchimp', cell: (row) => <MailchimpCell row={row} /> },
  created_at: { header: 'Aangemaakt', cell: (row) => <RelativeTime iso={row.created_at} /> },
  updated_at: { header: 'Gewijzigd', cell: (row) => <RelativeTime iso={row.updated_at} /> },
}

export function listColumns(): Record<string, ColumnRender<ListRow>> {
  return COLUMNS
}
